export default "__VITE_ASSET__CZY6hYwI__"